// TODO: Fix ts-nocheck PublicInfo
// @ts-nocheck
import { useCallback, useEffect, useState } from 'react';

import BasicInfo from './components/BasicInfo';
import LifeStory from './LifeStory';
import LoadingCircle from '../../../_shared/LoadingCircle';
//import Needs from './Needs';
import SupplementalQuestions from './SupplementalQuestions';

import { isObjectEmpty } from 'util/index';
import RequestErrorModal from 'components/_shared/RequestErrorModal';
import useUpdatePublicProfile from 'hooks/useUpdatePublicProfile';

import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        publicInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '60px',
            padding: '30px 12% 60px 12%'
        },
        infoContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '24px'
        }
    })
);

type PublicInfoProps = {
    holder: {
        description: string;
        id: number;
        name: string;
        photo: string;
    };
    homelessLifeStorySuccess: boolean;
    isSubmittingHomelessLifeStory: boolean;
    lifeStory: string;
    supplementalQuestions: any[];
    supplementalQuestionAnswers: [
        { answer: string; created_at: string; touchpoint_question_id: number }
    ];
    touchpointAnswers: any[];
    touchpointQuestions: any[];
    touchpointQuestionQOLs: any[];
    updateHomelessLifeStory: (id: number, description: string) => void;
    updateProfileCompletedItems: (item: string) => void;
    user: any;
};

const buildFormData = (changedState) => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(changedState)) {
        formData.append(`samaritan_member[${key}]`, value);
    }
    return formData;
};

const PublicInfo: React.FC<PublicInfoProps> = ({
    holder,
    homelessLifeStorySuccess,
    isSubmittingHomelessLifeStory,
    lifeStory,
    supplementalQuestions,
    supplementalQuestionAnswers,
    touchpointAnswers,
    touchpointQuestions,
    touchpointQuestionQOLs,
    updateHomelessLifeStory,
    updateProfileCompletedItems,
    user
}) => {
    const classes = useStyles();

    const { description, id, name, photo } = holder;
    const { updatePublicProfile, isError, isLoading, isSuccess, reset } =
        useUpdatePublicProfile();

    const [editName, setEditName] = useState(false);
    const [newName, setNewName] = useState(name);
    const [editProfilePicture, setEditProfilePicture] = useState(false);
    const [newProfilePicture, setNewProfilePicture] = useState(null);

    const handleSavePhoto = useCallback(() => {
        const changedState = {};

        if (newProfilePicture) {
            changedState['photo'] = newProfilePicture;
            updateProfileCompletedItems('photo');
        }

        if (!isObjectEmpty(changedState)) {
            const formData = buildFormData(changedState);
            updatePublicProfile(id, formData);
        } else {
            setEditProfilePicture(false);
        }
    }, [
        id,
        newProfilePicture,
        updateProfileCompletedItems,
        updatePublicProfile
    ]);

    const handleSaveName = useCallback(() => {
        const changedState = {};

        if (newName !== name && newName.length > 0) {
            changedState['name'] = newName;
            updateProfileCompletedItems('name');
        }

        if (!isObjectEmpty(changedState)) {
            const formData = buildFormData(changedState);
            updatePublicProfile(id, formData);
        } else {
            setEditName(false);
        }
    }, [id, name, newName, updateProfileCompletedItems, updatePublicProfile]);

    useEffect(() => {
        if (isSuccess) {
            reset();
        }
    }, [isSuccess, reset]);

    const basicInfoProps = {
        editName,
        editProfilePicture,
        handleSaveName,
        handleSavePhoto,
        name,
        newName,
        newProfilePicture,
        photo,
        setEditName,
        setEditProfilePicture,
        setNewName,
        setNewProfilePicture
    };

    if (isLoading) {
        return (
            <div className={classes.publicInfoContainer}>
                <div style={{ width: '100%', height: '100px' }}>
                    <LoadingCircle>Saving Changes</LoadingCircle>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.publicInfoContainer}>
            {isError && (
                <RequestErrorModal
                    open={isError}
                    onClose={() => reset()}
                    message="Changes couldn't be saved."
                    retryFunc={handleSave}
                />
            )}
            <BasicInfo {...basicInfoProps} />
            <LifeStory
                description={description}
                homelessLifeStorySuccess={homelessLifeStorySuccess}
                id={id}
                isSubmittingHomelessLifeStory={isSubmittingHomelessLifeStory}
                lifeStory={lifeStory}
                name={name}
                updateHomelessLifeStory={updateHomelessLifeStory}
            />
            {supplementalQuestions.length > 0 && (
                <SupplementalQuestions
                    answers={supplementalQuestionAnswers}
                    id={id}
                    name={name}
                    questions={supplementalQuestions}
                    updateProfileCompletedItems={updateProfileCompletedItems}
                />
            )}
        </div>
    );
};

export default PublicInfo;
